/**
 * Created by r4zi4l on 09.02.2021
 */

const Map2dAdviceSpawnLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);

    const prizes = cleverapps.toArray(options && options.prizes);
    if (prizes && prizes.length > 0) {
        this.prizes = prizes;
    }

    this.ingredients = options && options.ingredients;
    this.adviceMoveCustomization = options && options.adviceMoveCustomization;
};

Map2dAdviceSpawnLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceSpawnLogic.prototype.constructor = Map2dAdviceSpawnLogic;

Map2dAdviceSpawnLogic.prototype.checkUnitPrizes = function (unit) {
    if (["chest", "unitsshop"].indexOf(unit.getType()) !== -1) {
        return true;
    }

    const customer = unit.findComponent(Customer);
    if (customer) {
        if (!this.ordered && customer.getState() === Customer.STATE_EMPTY) {
            this.ordered = true;
            customer.order();
        }

        if (customer.getState() === Customer.STATE_READY) {
            return true;
        }

        return customer.isEnoughIngredientsForRecipe();
    }

    if (unit.prizes && unit.prizes.length) {
        return cleverapps.contains(unit.prizes, this.prizes, Unit.GetKey);
    }

    return false;
};

Map2dAdviceSpawnLogic.prototype.findMove = function () {
    if (this.ingredients && !Map2d.currentMap.stock.canTakeIngredients(this.ingredients)) {
        return;
    }

    const unit = this.listAvailableUnits().filter(this.checkUnitPrizes.bind(this))[0];
    if (!unit) {
        return;
    }

    const move = {};

    if ((Map2dLocation.currentLocation.tutorial.checkConditions({ unit }) || cleverapps.tutorial.checkConditions({ unit })) && ["chest", "unitsshop"].indexOf(unit.getType()) !== -1
        || Map2d.currentMap.findEmptySlot(unit.x, unit.y)) {
        move.cells = [cc.p(unit.x, unit.y)];
        move.arrow = move.cells[0];
        move.highlight = move.cells;

        if (this.adviceMoveCustomization) {
            move.fingerDrag = [move.cells[0]];
        }
    }

    const currentWindow = cleverapps.focusManager.currentWindow();
    if (currentWindow && (currentWindow instanceof OrdersWindow && unit.getType() === "hero"
        || currentWindow instanceof OpenChestWindow && unit.getType() === "chest"
        || ShopWindow.getUnitsController(currentWindow) && unit.getType() === "unitsshop")) {
        move.window = Map2d.SPAWN;
    }

    if (["rpcustomer", "eacustomer"].includes(unit.getType())) {
        const unitView = unit.onGetView();
        const unitAdditionalView = unitView && unitView.getAdditionalView("extended_ingredients");
        if (unitAdditionalView) {
            move.unitAdditionalView = Map2d.SPAWN;
        }
    }

    if (move.cells || move.window || move.unitAdditionalView) {
        return move;
    }
};
